import React from 'react';

import type { FilterOptionsProps } from 'src/components/organisms/Filter/containers/FilterOptionsContainer.types';
import { TreeContainer } from 'src/components/organisms/Filter/containers/TreeContainer';
import { CheckboxGroupWrapper } from './CheckboxGroupWrapper';
import type { ExpandableContentTogglePayload } from './FilterOptionsExpandableContent';
import { RadioButtonGroupWrapper } from './RadioButtonGroupWrapper';
import { RangeInputWrapper } from './RangeInputWrapper/RangeInputWrapper';

export const FilterOptions = ({
  onExpandableContentToggle,
  totalFiltersAppliedCount,
  totalSelectedFilterOptionsCount,
  ...restOfProps
}: FilterOptionsProps) => {
  const props = {
    ...restOfProps,
    onExpandableContentToggle: (payload: ExpandableContentTogglePayload) => {
      onExpandableContentToggle({
        ...payload,
        totalFiltersAppliedCount,
        totalSelectedFilterOptionsCount,
      });
    },
  };

  switch (props.filter.type) {
    case 'checkbox':
      return <CheckboxGroupWrapper {...props} />;
    case 'radio':
      return <RadioButtonGroupWrapper {...props} />;
    case 'range':
      return <RangeInputWrapper {...props} />;
    case 'tree':
      return <TreeContainer {...props} />;
    default:
      return null;
  }
};
